import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ResolvePickingJobMutationVariables = Types.Exact<{
  picking_job_id: Types.Scalars['ID'];
  destination: Types.PickingJobResolutionDestination;
  reason: Types.Scalars['String'];
}>;


export type ResolvePickingJobMutation = { __typename?: 'Mutation', resolvePickingJob: { __typename?: 'PickingJob', id: string, status: Types.PickingJobStatus, resolution?: { __typename?: 'PickingJobResolution', destination: Types.PickingJobResolutionDestination, resolved_at: string, reason: string, resolved_by?: { __typename?: 'IdName', id: string, name: string } | null } | null } };


export const ResolvePickingJobDocument = gql`
    mutation ResolvePickingJob($picking_job_id: ID!, $destination: PickingJobResolutionDestination!, $reason: String!) {
  resolvePickingJob(
    picking_job_id: $picking_job_id
    destination: $destination
    reason: $reason
  ) {
    id
    status
    resolution {
      destination
      resolved_at
      resolved_by {
        id
        name
      }
      reason
    }
  }
}
    `;
export type ResolvePickingJobMutationFn = Apollo.MutationFunction<ResolvePickingJobMutation, ResolvePickingJobMutationVariables>;

/**
 * __useResolvePickingJobMutation__
 *
 * To run a mutation, you first call `useResolvePickingJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolvePickingJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolvePickingJobMutation, { data, loading, error }] = useResolvePickingJobMutation({
 *   variables: {
 *      picking_job_id: // value for 'picking_job_id'
 *      destination: // value for 'destination'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useResolvePickingJobMutation(baseOptions?: Apollo.MutationHookOptions<ResolvePickingJobMutation, ResolvePickingJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolvePickingJobMutation, ResolvePickingJobMutationVariables>(ResolvePickingJobDocument, options);
      }
export type ResolvePickingJobMutationHookResult = ReturnType<typeof useResolvePickingJobMutation>;
export type ResolvePickingJobMutationResult = Apollo.MutationResult<ResolvePickingJobMutation>;
export type ResolvePickingJobMutationOptions = Apollo.BaseMutationOptions<ResolvePickingJobMutation, ResolvePickingJobMutationVariables>;